<template>
  <div class="box">
    <van-nav-bar
      :title="title"
      left-arrow
      right-text="发表"
      @click-left="backToLast"
      @click-right="submit"
    >
    </van-nav-bar>
    <div class="top_box">
      <div class="left_label">总体评价</div>
      <van-rate
        v-model="allScore"
        :size="25"
        color="#3377FF"
        void-icon="star"
        void-color="#eee"
        @change="onChange1"
      />
      <div class="top_star_desc">{{ allLabel }}</div>
    </div>
    <div class="content_box">
      <div class="input_content">
        <van-field
          class="content_input"
          v-model="inputContent"
          type="textarea"
          placeholder="请输入评论内容"
          :border="false"
          :autosize="true"
        ></van-field>
      </div>
      <div class="addPic_box">
        <!-- <van-uploader
          v-model="picList"
          :after-read="uploadCertificationCardUrl1"
          :max-size="maxSize"
          @oversize="oversize"
          @delete="deletePic"
        >
        </van-uploader> -->
        <UploadImg
          v-model="picList"
          :grade="'2'"
          :maxSize="maxSize"
          @oversize="oversize"
          key="picList"
          :multiple="true"
          :maxCount="3"/>
      </div>
      <!-- <div class="input_bottom_box">
        <div class="input_bottom_left">
          <img
            class="bottom_left_img"
            v-if="isHidden"
            src="@/assets/order/selected.png"
            @click="doneHidden"
          />
          <img
            class="bottom_left_img"
            v-else
            src="@/assets/order/unselected.png"
            @click="doneHidden"
          />
          <div class="hidden_text">匿名评论</div>
        </div>
        <div class="star_text">满意请给五星好评哦</div>
      </div> -->
    </div>
    <!-- <div class="top_box">
      <div class="left_label">服务</div>
      <van-rate
        v-model="serverScore"
        :size="25"
        color="#3377FF"
        void-icon="star"
        void-color="#eee"
        @change="onChange2"
      />
      <div class="top_star_desc">{{ serverLabel }}</div>
    </div>
    <div class="top_box">
      <div class="left_label">卫生</div>
      <van-rate
        v-model="healthScore"
        :size="25"
        color="#3377FF"
        void-icon="star"
        void-color="#eee"
        @change="onChange3"
      />
      <div class="top_star_desc">{{ healthLabel }}</div>
    </div>
    <div class="top_box">
      <div class="left_label">环境</div>
      <van-rate
        v-model="environmentScore"
        :size="25"
        color="#3377FF"
        void-icon="star"
        void-color="#eee"
        @change="onChange4"
      />
      <div class="top_star_desc">{{ environmentLabel }}</div>
    </div>
    <div class="top_box">
      <div class="left_label">设施</div>
      <van-rate
        v-model="facilitiesScore"
        :size="25"
        color="#3377FF"
        void-icon="star"
        void-color="#eee"
        @change="onChange5"
      />
      <div class="top_star_desc">{{ facilitiesLabel }}</div>
    </div> -->
  </div>
</template>

<script>
import { getImgUrl } from "@/mixins/getImgUrl";
import { getFilePath } from "../../../utils";
import { Notify } from "vant";
import UploadImg from '../../user-register-info/components/upload.vue'
export default {
  components: {UploadImg},
  mixins: [getImgUrl],
  data() {
    return {
      title: "",
      allScore: 0, //总评分
      serverScore: 0, //服务
      healthScore: 0, //卫生
      environmentScore: 0, //环境
      facilitiesScore: 0, //设施
      allLabel: "",
      serverLabel: "",
      healthLabel: "",
      environmentLabel: "",
      facilitiesLabel: "",
      scoreList: ["很差", "差", "一般", "好", "很好"],
      inputContent: "",
      isHidden: false, //是否匿名 勾选
      commentPicVos: [],
      picList: [],
      maxSize: 10 * 1000 * 1024,
    };
  },
  methods: {
    backToLast() {
      this.$router.go(-1);
    },
    //发表
    submit() {
      if (this.allScore == 0) {
        this.$toast("请先评分");
        return false;
      }
      if (this.inputContent.length == 0) {
        this.$toast("请输入评论内容");
        return false;
      }
      //   hotel: 0, // 酒店
      // ticket: 1, // 门票 景区
      // line: 2, // 线路
      // air_ticket: 3,// 机票
      // goods: 4, // 特产商品
      // guide: 5, //导服
      // visa: 6, // 签证
      // combo: 7, // 套餐
      // insurance: 8, // 保险
      // repast : 9, // 餐饮
      // pack: 10 // 套餐
      var productType = this.$route.query.productType
      productType = parseInt(productType)
      //1门票 2酒店 3线路 4商品 5机票 6签证 7导服 8餐饮 9组合 10 套餐
      if (productType === 0){
        productType = 2
      }else if (productType === 1){
        productType = 1
      }else if (productType === 2){
        productType = 3
      }else if (productType === 3){
        productType = 5
      }else if (productType === 4){
        productType = 4
      }else if (productType === 5){
        productType = 7
      }else if (productType === 6){
        productType = 6
      }else if (productType === 9){
        productType = 8
      }
      var params = {
        organizationId: this.$store.state.orgId,
        payerId: this.$store.state.userInfo_v2.user.userId,
        productId: this.$route.query.productId,
        productType: productType,
        orderId: this.$route.query.orderNo,
        stars: this.allScore,
        commentContent: this.inputContent,
        productName: this.$route.query.productName,
        // payerAvatarUrl: ,
        payerNickName: this.$store.getters.userInfo_v2.user.userName || "",
        // commentTagVos: [],
      };
      if (this.commentPicVos.length > 0) {
        params.commentPicVos = this.commentPicVos;
      }
      this.$API.z_order
        .addComment(params)
        .then((res) => {
          if (res.code == 200) {
            this.$toast("发表评价成功！");
            // this.checkComment(res.data);
            this.$router.push({
              path: "/order",
            });
          }
        })
        .catch((err) => {});
    },
    //前端强制审核评论成功
    checkComment(id) {
      var query = {
        commentId: id,
        status: "1",
      };
      this.$API.z_product.checkComment(query).then((res) => {
        this.$router.push({
          path: "/order",
        });
      });
    },
    onChange1(value) {
      this.allLabel = this.scoreList[value - 1];
    },
    // onChange2(value) {
    //   this.serverLabel = this.scoreList[value - 1];
    // },
    // onChange3(value) {
    //   this.healthLabel = this.scoreList[value - 1];
    // },
    // onChange4(value) {
    //   this.environmentLabel = this.scoreList[value - 1];
    // },
    // onChange5(value) {
    //   this.facilitiesLabel = this.scoreList[value - 1];
    // },
    //添加图片
    uploadCertificationCardUrl1(file) {
      if (this.commentPicVos.length >= 3) {
        this.$toast("最多选择3张图片");
        return false;
      } else {
        var that = this;
        this.uploadFile(file, (res) => {
          // that.picList.push({ url: getFilePath(res) });
          that.commentPicVos.push({
            picUrl: res,
            picOrder: this.picList.length,
          });
        });
      }
    },
    oversize() {
      Notify({ type: "warning", message: "请上传10M大小以内的图片" });
    },
    uploadFile(file, callBack) {
      // 此时可以自行将文件上传至服务器
      const toast = this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: "上传中...",
      });
      const formData = new FormData();
      formData.append("file", file.file);
      this.$API.user.uploadFile(formData).then((res) => {
        toast.clear();
        callBack(res.data);
      });
    },
    deletePic(value, detail) {
      console.log("详情", detail);
      this.commentPicVos.splice(detail.index, 1);
    },
    //添加视频
    addMedia() {},
    doneHidden() {
      this.isHidden = !this.isHidden;
    },
  },
  mounted() {
    this.title = this.$route.query.title;
  },
};
</script>

<style lang="scss" scoped>
.box {
  background-color: #ffffff;

  ::v-deep .van-icon {
    color: #000;
  }
  ::v-deep .van-nav-bar__text {
    color: #000;
  }
  ::v-deep .van-ellipsis {
    color: #000;
  }
  .top_box {
    margin-top: vw(35);
    display: flex;
    flex-direction: row;
    align-items: center;
    .left_label {
      color: #333333;
      font-size: vw(30);
      margin-right: vw(34);
      margin-left: vw(30);
    }
    .top_star_desc {
      color: #666666;
      font-size: vw(26);
      margin-left: vw(49);
    }
  }
  .content_box {
    margin-top: vw(30);
    margin-left: vw(30);
    margin-right: vw(30);
    // height: vw(519);
    background-color: #f4f6f9;
    border-radius: vw(8);
    padding-bottom: vw(30);
    .input_content {
      margin-left: vw(20);
      margin-right: vw(20);
      margin-top: vw(25);
      .content_input {
        height: vw(280);
        background-color: #f4f6f9;
      }
    }
    .addPic_box {
      margin-top: vw(40);
      margin-right: vw(30);
      margin-left: vw(10);
      display: flex;
      flex-direction: row;
      align-items: center;
      .addMedia_box {
        width: vw(154);
        height: vw(154);
        display: flex;
        flex-direction: column;
        align-items: center;
        .media_img {
          width: vw(61);
          height: vw(61);
        }
        .media_ic {
          margin-top: vw(6);
          margin-bottom: vw(5);
          height: vw(50);
          width: vw(55);
        }
        .media_text {
          margin-top: vw(20);
          color: #666666;
          font-size: vw(26);
        }
      }
    }
    .input_bottom_box {
      //   margin-top: vw(30);
      margin-left: vw(30);
      margin-right: vw(30);
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .input_bottom_left {
        display: flex;
        flex-direction: row;
        align-items: center;
        .bottom_left_img {
          width: vw(30);
          height: vw(30);
        }
        .hidden_text {
          margin-left: vw(20);
          color: #333333;
          font-size: vw(28);
        }
      }
      .star_text {
        color: #999999;
        font-size: vw(24);
      }
    }
  }
}
</style>
